import React from 'react';
import moment from 'moment';
import * as StyledArticleBox from './articleBox.styles';
import {
	Columns, Column
} from '../base';
import { withCropOptions } from '../../helpers/images/withCropOptions';

const ArticleBox = ({
	Title = '',
	PublishDate = '',
	Url = '',
	Summary = '',
	Images = []
}) => {
	const date = moment(PublishDate);

	return (
		<StyledArticleBox.Link to={Url}>
			<Columns gapless style={{ height: '100%' }}>
				<Column gapless tablet={1} desktopSmall={6 / 10}>
					<StyledArticleBox.ContentWrapper>
						<StyledArticleBox.Date>{date.format('DD. MMMM YYYY')}</StyledArticleBox.Date>
						<StyledArticleBox.Title>{Title}</StyledArticleBox.Title>
						<StyledArticleBox.Summary>
							{Summary.substring(0, 155)}
							{Summary.length > 155 && <span>...</span>}
						</StyledArticleBox.Summary>
					</StyledArticleBox.ContentWrapper>
				</Column>
				<Column gapless tablet={1} desktopSmall={4 / 10}>
					<StyledArticleBox.Image
						image={withCropOptions(Images[0])}
						desktopWidth="1000"
						desktopHugeWidth="600"
						retinaWidth="600" />
				</Column>
			</Columns>
		</StyledArticleBox.Link>
	);
};

export default ArticleBox;
